/**
 * Move delayed result swaps below the scored viewport before React commits.
 *
 * `useLayoutEffect` is too late for CLS: the browser can attribute the DOM
 * mutation before the effect scrolls. Call this synchronously immediately
 * before the state update that replaces a form with a result.
 */
export function anchorResultSwapBeforeCommit() {
  if (typeof window === "undefined") return;
  const root = document.documentElement;
  const scrollingElement = document.scrollingElement ?? root;
  const previousOverflowAnchor = root.style.overflowAnchor;

  // Chrome's native scroll anchoring can preserve the focused submit region
  // when React removes it, undoing a plain scrollTo in the same commit. Disable
  // that adjustment through the next paint and set scrollTop directly so the
  // layout mutation starts with a synchronously updated viewport.
  root.style.overflowAnchor = "none";
  scrollingElement.scrollTop = 0;
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      root.style.overflowAnchor = previousOverflowAnchor;
    });
  });
}
